<div class="container col flex-height">
  <div class="flex-child grow container col">
    <div class="options flex-child container row">
      <label class="flex-child option-label">
        <b>Field:</b>
        <select #fieldSelect [(ngModel)]="selectedField" (change)="changeField()">
          <option *ngFor="let column of layerColumns" [value]="column.name">{{ column.alias }}</option>
        </select>
      </label>
      <label class="flex-child option-label" *ngIf="theme && theme.rendererType === 'unique-value'">
        <b>Add value:</b>
        <div>
          <select class="button-group" style="display: inline-block;" [(ngModel)]="classBreakToAdd" [disabled]="availableClassBreaks.length === 0">
            <option></option>
            <option *ngFor="let classBreak of availableClassBreaks" [value]="classBreak.info.label">{{ classBreak.info.label }}</option>
          </select>
          <button class="btn btn-white button-group" (click)="addClassBreak()" [disabled]="!classBreakToAdd">
            <span class="icon-ui-plus"></span>
          </button>
        </div>
      </label>
      <button class="btn btn-white" (click)="addClassBreak()" [disabled]="loadingData || errorMessage" *ngIf="theme && theme.rendererType === 'class-break'">
        <span class="icon-ui-plus"></span>
        Add Class Break
      </button>
      <label class="container col option-label">
        <b>Theme Type:</b>
        <div class="toggle-switch flex-child grow container flex-align-items-center" [class.disabled]="!theme || loadingData || (!(theme.isNumeric || theme.isDate))">
          <span class="toggle-label left font-size--1">Range</span>
          <input type="checkbox" class="toggle-switch-input" [checked]="displayRendererType === 'unique-value'" (click)="toggleRendererType()" [disabled]="!theme || loadingData || (!(theme.isNumeric || theme.isDate))">
          <span class="toggle-switch-track margin-right-1"></span>
          <span class="toggle-label font-size--1">Unique</span>
        </div>
      </label>
    </div>
  </div>
  <div class="slider flex-child grow container col flex-height class-breaks">
    <div *ngIf="errorMessage" class="color alert-yellow is-active flex-child trailer-half">
      {{ errorMessage }}
    </div>
    <div *ngIf="loadingData && !errorMessage" class="loader is-active color">
      <div class="loader-bars"></div>
      <div class="loader-text">Loading...</div>
    </div>
    <table *ngIf="theme && theme.classBreaks && !errorMessage" class="flex-child">
      <tbody>
        <tr *ngFor="let classBreak of selectedClassBreaks; index as i">
          <td *ngIf="theme.rendererType === 'unique-value'">
            <button class="btn btn-small btn-transparent" (click)="moveValueUp(classBreak)" [disabled]="loadingData || i == 0">
              <span class="icon-ui-up-arrow" aria-hidden="true"></span>
            </button>
            <button class="btn btn-small btn-transparent" (click)="moveValueDown(classBreak)" [disabled]="loadingData || i == selectedClassBreaks.length - 1">
              <span class="icon-ui-down-arrow" aria-hidden="true"></span>
            </button>
          </td>
          <td><span #symbolPreview class="symbolPreview" [attr.data-label]="classBreak.info.label" (click)="editSymbol(classBreak)"></span></td>
          <td>
            <ng-container *ngIf="theme.rendererType === 'unique-value'">{{ classBreak.info.label }}</ng-container>
            <ng-container *ngIf="theme.rendererType === 'class-break'">
              <ng-container *ngIf="classBreak.info.label !== classBreakToEdit">{{ classBreak.info.minValue }} - {{ classBreak.info.maxValue }}</ng-container>
              <ng-container *ngIf="classBreak.info.label === classBreakToEdit" class="editClassBreak">
                <input type="number" [(ngModel)]="newMinValue" (keyup)="editClassBreakKeyUp(classBreak, $event)"> -
                <input type="number" [(ngModel)]="newMaxValue" (keyup)="editClassBreakKeyUp(classBreak, $event)">
              </ng-container>
            </ng-container>
          </td>
          <td>
            <button *ngIf="theme.rendererType === 'class-break' && classBreak.info.label !== classBreakToEdit"
                    class="btn btn-small btn-transparent" (click)="editClassBreak(classBreak)"
                    [disabled]="loadingData">
              <span class="icon-ui-edit" aria-hidden="true"></span>
            </button>                    
            <button *ngIf="theme.rendererType === 'unique-value' || i === selectedClassBreaks.length - 1"
                    class="btn btn-small btn-transparent" (click)="removeClassBreak(classBreak)"
                    [disabled]="loadingData">
              <span class="icon-ui-trash" aria-hidden="true"></span>
            </button>
            <button *ngIf="classBreak.info.label === classBreakToEdit" class="btn btn-small btn-transparent" (click)="saveClassBreak(classBreak)">
              <span class="icon-ui-check-mark" aria-hidden="true"></span>
            </button>
            <button *ngIf="classBreak.info.label === classBreakToEdit" class="btn btn-small btn-transparent" (click)="cancelEditClassBreak(classBreak)">
              <span class="icon-ui-close" aria-hidden="true"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="flex-child container row justify-content-space-between leader-half">
    <button class="btn btn-clear btn-small" (click)="resetColors()">Reset Colors</button>
    <button class="btn btn-clear btn-small" (click)="stackLineWidths()">Stack Line Widths</button>
    <div class="flex-child grow container row flex-justify-content-end">
      <button class="btn btn-clear" (click)="closeWindow(false)">Cancel</button>
      <button class="btn" (click)="closeWindow(true)" [disabled]="loadingData || errorMessage">Okay</button>
    </div>
  </div>
</div>
